import {FIRST_CHAR_NUMBER_REGEX, SPECIAL_REQUIRED_REGEX} from "@/components/constants";


/**
 * 비밀번호 유효성 검사 결과
 * @typedef {object} ValidateMemberResult
 * @property {boolean} isValid - 유효성 여부
 * @property {string} reason - 실패 사유
 */

/**
 * 멤버 관련 페이지 비밀번호 유효성 검사
 * @param {string} value - 비밀번호 문자열
 * @returns {ValidateMemberResult}
 */
export const validateMember = (value) => {
    if (FIRST_CHAR_NUMBER_REGEX.test(value)) {
        return {
            isValid: false,
            reason: "첫 글자는 숫자가 될 수 없습니다.",
        };
    }
    if (!SPECIAL_REQUIRED_REGEX.test(value)) {
        return {
            isValid: false,
            reason: "특수문자가 최소 1개 이상 포함되어야 합니다.",
        };
    }
    return {
        isValid: true,
        reason: "",
    };
}

/**
 * HTML 태그 제거
 * @param {string} string - HTML 문자열
 * @returns {string|*}
 */
export const stripHtml = (string) => {
    if (typeof string !== "string") return string;
    return string
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/\u200B/g, "")
        .replace(/\s+/g, " ")
        .trim();
};

/**
 * 클립보드 복사
 * @param {string} text - 복사할 문자열
 * @returns {Promise<boolean>}
 */
export const copyToClipboard = async (text) => {
    if (typeof window === "undefined") return false;
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-9999px";
        textArea.style.top = "-9999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(textArea);
        return ok;
    } catch (e) {
        console.error("copyToClipboard error:", e);
        return false;
    }
}

/**
 * 전화번호 관련 필드 병합 후 targetKey로 저장
 * @param {Object} obj - 대상 객체
 * @param {Array<string>} fields - 병합 대상 필드 리스트
 * @param {string} targetKey - 저장 대상 key
 * @returns {Object}
 */
export const foldTelFields = (obj, fields, targetKey) => {
    const parts = fields.map((key) => (obj[key] ?? "").toString().trim()).filter((string) => string !== "");
    if (parts.length) {
        obj[targetKey] = parts.join("-");
    } else {
        delete obj[targetKey];
    }
    fields.forEach((key) => {
        delete obj[key];
    });
    return obj;
}